import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Phone, ExternalLink } from 'lucide-react';
import { useMenu } from '@/lib/useMenu';

const FooterLink = ({ item }) => {
  const isExternal = item.link_type === 'external' || (item.href || '').startsWith('http');
  if (isExternal) {
    return (
      <a
        href={item.href}
        target={item.open_in_new_tab ? '_blank' : undefined}
        rel={item.open_in_new_tab ? 'noreferrer' : undefined}
        className="hover:text-gold transition-colors inline-flex items-center"
        data-testid={`footer-custom-${item.id || item.label}`}
      >
        {item.label}{item.open_in_new_tab && <ExternalLink size={11} className="inline-block ml-1 -mt-0.5 opacity-60"/>}
      </a>
    );
  }
  return (
    <Link
      to={item.href || '#'}
      target={item.open_in_new_tab ? '_blank' : undefined}
      className="hover:text-gold transition-colors"
      data-testid={`footer-custom-${item.id || item.label}`}
    >
      {item.label}
    </Link>
  );
};

export const Footer = () => {
  const { footer: customFooterLinks } = useMenu();
  return (
  <footer className="border-t border-kc mt-20 bg-white">
    {/* Crisis bar */}
    <div className="bg-ink text-white">
      <div className="kc-container py-3 text-center text-xs md:text-sm flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
        <span className="inline-flex items-center gap-2"><Phone size={14} className="text-[color:var(--kc-gold)]"/> In crisis or need to talk? <strong>Call or text 988</strong> — free, confidential, 24/7.</span>
      </div>
    </div>
    <div className="kc-container py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div className="md:col-span-2">
        <Logo />
        <p className="mt-4 text-sm text-muted-kc max-w-md">A learning home for mindset, growth, and taking back your headspace. Created by Mickey Trivett.</p>
        <div className="mt-4 font-display tracking-[0.18em] uppercase text-sm">LIVE LIFE. <span className="text-gold">DO GOOD.</span> BE HAPPY.</div>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <span className="text-[11px] tracking-[0.18em] uppercase text-muted-kc">Learn</span>
        <Link to="/courses" className="hover:text-gold transition-colors">Courses</Link>
        <Link to="/courses/headspace" className="hover:text-gold transition-colors">HEADSPACE</Link>
        <Link to="/resources" className="hover:text-gold transition-colors">Resources</Link>
        <Link to="/support" className="hover:text-gold transition-colors" data-testid="footer-support">Support My Work</Link>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <span className="text-[11px] tracking-[0.18em] uppercase text-muted-kc">{customFooterLinks.length > 0 ? 'More' : 'About'}</span>
        <a href="https://www.kickasslifecoach.com" target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">kickasslifecoach.com</a>
        <span className="text-muted-kc">@mickeytrivett</span>
        {customFooterLinks.map((item) => <FooterLink key={item.id} item={item}/>)}
      </div>
    </div>
    <div className="border-t border-kc">
      <div className="kc-container py-5 text-xs text-muted-kc flex flex-col md:flex-row md:items-center justify-between gap-3">
        <span>© {new Date().getFullYear()} Kickass Course. All rights reserved.</span>
        <div className="flex items-center gap-4">
          <Link to="/legal/privacy" className="hover:text-gold transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
          <span className="text-muted-kc/40">·</span>
          <Link to="/legal/terms" className="hover:text-gold transition-colors" data-testid="footer-terms">Terms of Service</Link>
        </div>
        <span className="text-muted-kc">Not a substitute for professional medical or mental health advice.</span>
      </div>
    </div>
  </footer>
  );
};
